<template>
  <div class="research-report-container">
    <div class="row header-tab">
      <div class="tab-btn" :class="{'active': selectedOptionTab === 'text'}" @click="onListTab('text')">文本</div>
      <div class="tab-btn" :class="{'active': selectedOptionTab === 'chart'}" @click="onListTab('chart')">图表</div>
    </div>
    <div>
    <div class="filter">
      <div class="row filter-content" v-if="selectedOptionTab === 'text' && data.length">
        <div class="filter-content-left">
          <el-checkbox class="check-all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选本页</el-checkbox>
          <span class="news-count" v-if="!this.checkedId.length&&totalCount>=10000"><span class="count">{{totalCount}}+</span>条相关研报</span>
          <span class="news-count" v-if="!this.checkedId.length&&totalCount<10000">共<span class="count">{{totalCount}}</span>条相关研报</span>
          <el-button v-if="this.checkedId.length" class="batch-btn" @click="batchCollectionTextBtnClick">收藏</el-button>
          <el-button v-if="this.checkedId.length" class="batch-btn" @click="batchDownloadTextBtnClick">下载</el-button>
        </div>
        <div class="filter-content-right">
          <el-button v-if="showDetails && isShowDetailsBtn" class="show-hidden-details" @click="onShowHiddenDetails">全部隐藏详情</el-button>
          <el-button v-if="!showDetails && isShowDetailsBtn" class="show-hidden-details" @click="onShowHiddenDetails">全部显示详情</el-button>
          <el-select v-model="option" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row filter-content" v-if="selectedOptionTab === 'chart' && chartData.length">
        <div class="filter-content-left">
          <el-checkbox class="check-all" :indeterminate="chartIsIndeterminate" v-model="chartCheckAll" @change="chartHandleCheckAllChange">全选本页</el-checkbox>
          <span class="news-count" v-if="!this.chartCheckedId.length&&chartTotalCount>=10000"><span class="count">{{chartTotalCount}}+</span>条相关研报</span>
          <span class="news-count" v-if="!this.chartCheckedId.length&&chartTotalCount<10000">共<span class="count">{{chartTotalCount}}</span>条相关研报</span>
          <el-button v-if="this.chartCheckedId.length" class="batch-btn" @click="batchCollectionChartBtnClick">收藏</el-button>
          <el-button v-if="this.chartCheckedId.length" class="batch-btn" @click="batchDownloadChartBtnClick">下载</el-button>
        </div>
        <div class="filter-content-right">
          <el-select v-model="option" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    </div>
    <div class="content-list" v-if="selectedOptionTab === 'text'" v-loading="isLoading">
      <research-report-text-list @noDownloadPermissions="noDownloadPermissions" @uncollect="textUncollect" @collection="textCollection" @download="download" @changeDetailStatus="changeDetailStatus" @change="changeChecked" :data="data"></research-report-text-list>
    </div>
    <div class="content-list" v-if="selectedOptionTab === 'chart'" v-loading="isLoading">
      <research-report-chart-list @noDownloadPermissions="noDownloadPermissions" @uncollect="figureUncollect" @collection="figureCollection" @download="download" @change="chartChangeChecked" :data="chartData"></research-report-chart-list>
    </div>
    <div class="row footer" v-if="(selectedOptionTab === 'text' && data.length) || (selectedOptionTab === 'chart' && chartData.length)">
      <div class="pager" v-if="selectedOptionTab === 'text'">
        <el-pagination
          class="left-bottom-pagination border-pagination"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
        ></el-pagination>
      </div>
      <div class="pager" v-if="selectedOptionTab === 'chart'">
        <el-pagination
          class="left-bottom-pagination border-pagination"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="chartTotalCount"
        ></el-pagination>
      </div>
      <!-- <div>
        <el-select v-model="pageOption" placeholder="请选择">
          <el-option
            v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div> -->
      <div class="page-size-selector row">
        <el-dropdown @command="handlePageSizeChange" class="page-size-dropdown">
          <span class="el-dropdown-link">
            {{pageSize}}条/页<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(size, index) in [20,50,100]" :key="index" :command="size">{{size}}条/页</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="empty-page" v-if="(selectedOptionTab === 'text' && !totalCount && !isLoading) || (selectedOptionTab === 'chart' && !chartTotalCount && !isLoading && this.text.include)">
      <img class="empty-page-img" src="../../assets/img/empty-page-list.svg" alt="">
      <div class="empty-page-word">很抱歉，没有找到搜索内容</div>
    </div>
    <div class="chart-empty-page" v-if="(selectedOptionTab === 'chart' && !chartTotalCount && !isLoading && !this.text.include)">
      <img class="chart-empty-page-img" src="../../assets/img/empty-page-img1.svg" alt="">
      <div class="chart-empty-page-word1">图表属于研报正文内容</div>
      <div class="chart-empty-page-word2">请搜索研报正文关键词或公司名称，才能有图表结果！！！</div>
    </div>
  </div>
</template>

<script>
import ResearchReportTextList from '@/components/research-report/ResearchReportTextList';
import ResearchReportChartList from '@/components/research-report/ResearchReportChartList';
import Mark from 'mark.js';

export default {
  data() {
    return {
      isShowDetailsBtn: false,
      pageNum: 1,
      pageSize: 20,
      showDetails: false,
      selectedOptionTab: 'text',
      checkAll: false,
      chartCheckAll: false,
      isIndeterminate: false,
      chartIsIndeterminate: false,
      checkedId: [],
      chartCheckedId: [],
      options: [
        {
          value: '时间最早',
          label: '时间最早'
        },
        {
          value: '时间最近',
          label: '时间最近'
        },
        {
          value: '按相关度',
          label: '按相关度'
        }
      ],
      option: '按相关度'
    };
  },
  props: {
    data: {
      type: Array
    },
    chartData: {
      type: Array
    },
    totalCount: {
      type: Number
    },
    chartTotalCount: {
      type: Number
    },
    highlight: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    pageNumData: {
      type: Number
    },
    selectedOptionTabData: {
      type: String
    },
    text: {
      type: Object
    }
  },
  methods: {
    noDownloadPermissions() {
      this.$emit('noDownloadPermissions');
    },
    batchCollectionTextBtnClick() {
      this.$emit('batchCollectionText', this.checkedId);
    },
    batchDownloadTextBtnClick() {
      this.$emit('batchDownloadText', this.checkedId);
    },
    batchCollectionChartBtnClick() {
      this.$emit('batchCollectionChart', this.chartCheckedId);
    },
    batchDownloadChartBtnClick() {
      this.$emit('batchDownloadChart', this.chartCheckedId);
    },
    textCollection(res) {
      this.$emit('textCollection', res);
    },
    textUncollect(id) {
      this.$emit('textUncollect', [id]);
    },
    figureUncollect(id) {
      this.$emit('figureUncollect', [id]);
    },
    figureCollection(res) {
      this.$emit('figureCollection', res);
    },
    download(res) {
      this.$emit('download', res);
    },
    onListTab(tabName) {
      this.selectedOptionTab = tabName;
      this.pageNum = 1;
      this.$emit('selectedTab', tabName);
    },
    handleCurrentChange(page) {
      this.pageNum = page; 
      this.$emit('pageNumChange', page);
    },
    handleCheckAllChange() {
      if (this.data.every(item => item.checked)) {
        this.data.forEach(item => {
          item.checked = false;
        });
      } else if (this.data.some(item => item.checked)) {
        this.data.forEach(item => {
          item.checked = true;
        });
      } else {
        this.data.forEach(item => {
          item.checked = true;
        });
      }
      this.changeChecked();
    },
    changeChecked() {
      if (this.data.every(item => item.checked)) {
        this.checkAll = true;
        this.isIndeterminate = false;
        this.checkedId = [];
        this.checkedId = this.data.map(item => {
          return {
            id: item.id,
            text: item.itxt
          };
        });
      } else if (this.data.some(item => item.checked)) {
        this.checkedId = [];
        this.checkAll = false;
        this.isIndeterminate = true;
        this.data.forEach(item => {
          if (item.checked) {
            this.checkedId.push(item);
          }
        });
      } else {
        this.checkedId = [];
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    chartHandleCheckAllChange() {
      if (this.chartData.every(item => item.checked)) {
        this.chartData.forEach(item => {
          item.checked = false;
        });
      } else if (this.chartData.some(item => item.checked)) {
        this.chartData.forEach(item => {
          item.checked = true;
        });
      } else {
        this.chartData.forEach(item => {
          item.checked = true;
        });
      }
      this.chartChangeChecked();
    },
    chartChangeChecked() {
      if (this.chartData.every(item => item.checked)) {
        this.chartCheckAll = true;
        this.chartIsIndeterminate = false;
        this.chartCheckedId = [];
        this.chartCheckedId = this.chartData.map(item => {
          return {
            id: item.id,
            pdfId: item.pdfId
          };
        });
      } else if (this.chartData.some(item => item.checked)) {
        this.chartCheckedId = [];
        this.chartCheckAll = false;
        this.chartIsIndeterminate = true;
        this.chartData.forEach(item => {
          if (item.checked) {
            this.chartCheckedId.push(item);
          }
        });
      } else {
        this.chartCheckedId = [];
        this.chartCheckAll = false;
        this.chartIsIndeterminate = false;
      }
    },
    onShowHiddenDetails() {
      if (this.data.every(item => item.showSummary)) {
        this.data.forEach(item => {
          item.showSummary = false;
        });
        this.showDetails = false;
      } else if (this.data.some(item => item.showSummary)) {
        this.data.forEach(item => {
          item.showSummary = true;
        });
        this.showDetails = true;
      } else {
        this.data.forEach(item => {
          item.showSummary = true;
        });
        this.showDetails = true;
      }
    },
    changeDetailStatus(id) {
      this.data.forEach(item => {
        if (item.id === id) {
          item.showSummary = !item.showSummary;
        }
      });
      if (this.data.every(item => item.showSummary)) {
        this.showDetails = true;
      } else if (this.data.some(item => item.showSummary)) {
        this.showDetails = false;
      } else {
        this.showDetails = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.$emit('pageOption', Number(size));
    }
  },
  updated() {
    const titleInstance = new Mark(document.querySelectorAll('.title'));
    titleInstance.mark(this.highlight.title || [], {
      element: 'span',
      className: 'highlight'
    });
    const textInstance = new Mark(document.querySelectorAll('.text'));
    textInstance.mark(this.highlight.text || [], {
      element: 'span',
      className: 'highlight'
    });
  },
  watch: {
    text(val) {
      if (val.include) {
        this.isShowDetailsBtn = true;
      } else if (!val.include) {
        this.isShowDetailsBtn = false;
      }
    },
    option(val) {
      this.pageNum = 1;
      this.$emit('sortByOption', val);
    },
    pageNumData(val) {
      if (val === 1) {
        this.pageNum = 1;
      } else {
        this.pageNum = val;
      }
    },
    selectedOptionTabData(val) {
      this.selectedOptionTab = val;
    }
  },
  components: {
    ResearchReportTextList,
    ResearchReportChartList
  }
};
</script>

<style lang="scss" scoped>
.research-report-container {
  position: relative;
  min-height: 516px;
  background-color: #ffffff;
  .header-tab {
    position: relative;
    height: 48px;
    box-shadow: inset 0px -1px 0px 0px#f2f3f7;
    width: 100%;
    padding: 14px 0 0 32px;
    font-size: 14px;
    color: #747990;
    .tab-btn {
      margin-right: 40px;
      font-weight: 500;
      cursor: pointer;
    }
    .active {
      position: relative;
      color: #171f46;
    }
    .active::after {
      content: '';
      position: absolute;
      bottom: 1px;
      left: 0px;
      width: 28px;
      height: 2px;
      background-color: #171f46;
    }
  }
  .filter {
    padding: 16px 32px 0;
    .filter-content {
      justify-content: space-between;
      height: 48px;
      line-height: 48px;
      box-shadow: inset 0px -1px 0px 0px#f2f3f7;
      .check-all {
        margin-right: 16px;
        color: #747990;
      }
      .news-count {
        color: #747990;
        font-size: 14px;
        .count {
          color: #171f46;
          font-size: 14px;
        }
      }
      .batch-btn {
        height: 32px;
        width: 60px;
        padding: 0;
        font-size: 14px;
        color: #171f46;
        border-radius: 2px;
        font-weight: 400;
        border: 1px solid #e5e6ee;
        &:hover {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:focus {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:active {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #f2f3f7;
        }
      }
      .batch-btn:last-child {
        margin-left: 16px;
      }
      .show-hidden-details {
        height: 32px;
        width: 116px;
        padding: 0;
        font-size: 14px;
        color: #171f46;
        border-radius: 2px;
        font-weight: 400;
        border: 1px solid #e5e6ee;
        &:hover {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:focus {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:active {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #f2f3f7;
        }
      }
    }
    
  }
  .content-list {
    padding: 0 32px;
  }
  .el-select {
    margin-left: 10px;
    width: 108px;
  }
  .footer {
    padding: 16px 32px 32px;
    justify-content: space-between;
    .page-size-selector {
      align-items: center;
      border: 1px solid #e5e6ee;
      border-radius: 2px;
      padding: 3px 12px;
      font-size: 12px;
    }
  }
  .empty-page {
    .empty-page-img {
      position: absolute;
      left: 50%;
      top: 188px;
      transform: translateX(-50%);
    }
    .empty-page-word {
      position: absolute;
      left: 50%;
      top: 370px;
      transform: translateX(-50%);
      font-size: 14px;
      font-weight: 500;
      color: #d1d2da;
    }
  }
  .chart-empty-page {
    .chart-empty-page-img {
      position: absolute;
      left: 50%;
      top: 152px;
      transform: translateX(-50%);
    }
    .chart-empty-page-word1 {
      position: absolute;
      left: 50%;
      top: 286px;
      transform: translateX(-50%);
      font-size: 14px;
      font-weight: 500;
      color: #2b76ff;
    }
    .chart-empty-page-word2 {
      position: absolute;
      left: 50%;
      top: 314px;
      transform: translateX(-50%);
      font-size: 14px;
      font-weight: 500;
      color: #747990;
    }
  }
}

  /deep/.el-select .el-input__inner {
    height: 32px;
    border: 1px solid #e5e6ee;
    border-radius: 2px;
    color: #171f46;
    &:hover {
      border: 1px solid #171f46;
    }
  }
  /deep/.el-select .el-input .el-select__caret {
    color: #171f46;
  }
  /deep/.el-select .el-input.is-focus .el-input__inner {
    border: 1px solid #e5e6ee;
  }
  /deep/ {
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #747990;
    }
    .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #2b76ff;
      border-color: #2b76ff;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2b76ff;
      border-color: #2b76ff;
    }
  }

</style>
